import React, { useState } from 'react';
import { Heart, CreditCard, Smartphone, Building, Gift, DollarSign, Check, ArrowLeft, Lock, Users } from 'lucide-react';
import axios from 'axios';


const DonationForm = () => {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');
  const [donationType, setDonationType] = useState('unique');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [donorInfo, setDonorInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: 'Bénin'
  });
  const [showReceipt, setShowReceipt] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [failed, setFailed] = useState('');

  // Montants prédéfinis
  const predefinedAmounts = [
    { amount: 5000, label: '5 000 FCFA', description: 'Participation symbolique' },
    { amount: 10000, label: '10 000 FCFA', description: 'Soutien régulier' },
    { amount: 25000, label: '25 000 FCFA', description: 'Don généreux' },
    { amount: 50000, label: '50 000 FCFA', description: 'Grand soutien' },
    { amount: 100000, label: '100 000 FCFA', description: 'Mécénat' }
  ];

  // Méthodes de paiement disponibles
  const paymentMethods = [
    {
      id: 'mobile_money',
      name: 'Mobile Money',
      icon: <Smartphone className="w-6 h-6" />,
      description: 'MTN Mobile Money, Moov Money',
      fee: '2%'
    },
    {
      id: 'card',
      name: 'Carte bancaire',
      icon: <CreditCard className="w-6 h-6" />,
      description: 'Visa, Mastercard',
      fee: '4.0%'
    },
    // { 
    //   id: 'bank', 
    //   name: 'Virement bancaire', 
    //   icon: <Building className="w-6 h-6" />,
    //   description: 'Transfert direct',
    //   fee: 'Gratuit'
    // }
  ];

  // Projets pour lesquels on peut faire un don
  const donationProjects = [
    {
      id: 'general',
      name: 'Soutien général FSF',
      description: 'Pour le fonctionnement de la communauté',
      icon: '🏛️'
    },
    // {
    //   id: 'events',
    //   name: 'Événements familiaux',
    //   description: 'Retraites, pèlerinages, célébrations',
    //   icon: '🎉'
    // },
    // {
    //   id: 'formation',
    //   name: 'Formation des couples',
    //   description: 'Sessions éducatives et spirituelles',
    //   icon: '📚'
    // },
    // {
    //   id: 'solidarity',
    //   name: 'Solidarité familiale',
    //   description: 'Aide aux familles en difficulté',
    //   icon: '🤝'
    // },
    // {
    //   id: 'youth',
    //   name: 'Activités jeunesse',
    //   description: 'Programmes pour les enfants FSF',
    //   icon: '👨‍👩‍👧‍👦'
    // }
  ];

  const [selectedProject, setSelectedProject] = useState('general');

  // Fonctions pour gérer les changements d'étape sans scroll
  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
    // Maintenir le focus sur le formulaire
    setTimeout(() => {
      const formSection = document.getElementById('don');
      if (formSection) {
        const rect = formSection.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!isVisible) {
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, 100);
  };

  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
    // Maintenir le focus sur le formulaire
    setTimeout(() => {
      const formSection = document.getElementById('don');
      if (formSection) {
        const rect = formSection.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!isVisible) {
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, 100);
  };

  const goToStep = (step) => {
    setCurrentStep(step);
    // Maintenir le focus sur le formulaire
    setTimeout(() => {
      const formSection = document.getElementById('don');
      if (formSection) {
        const rect = formSection.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!isVisible) {
          formSection.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, 100);
  };

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount('');
  };

  const handleCustomAmount = (value) => {
    setCustomAmount(value);
    setSelectedAmount(null);
  };

  const getCurrentAmount = () => {
    return selectedAmount || parseFloat(customAmount) || 0;
  };

  const getFee = () => {
    const amount = getCurrentAmount();
    const method = paymentMethods.find(m => m.id === paymentMethod);
    if (!method || method.fee === 'Gratuit') return 0;
    const percentage = parseFloat(method.fee.replace('%', ''));
    return (amount * percentage) / 100;
  };

  const getTotalAmount = () => {
    return getCurrentAmount() + getFee();
  };

  function redirectToPayment(data) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = process.env.REACT_APP_API_URL + '/cinef/payment/initialize';
    form.style.display = 'none';
    // form.target = '_blank'; // une seule fois, hors de la boucle

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFailed('');
    setIsProcessing(true);

    const donationData = {
      amount: getCurrentAmount(),
      fee: getFee(),
      total: getTotalAmount(),
      type: donationType,
      project: selectedProject,
      paymentMethod,
      donor: donorInfo,
      timestamp: new Date().toISOString()
    };

    console.log('Données de donation à envoyer à l\'API:', donationData);

    // Objet JS, PAS de JSON.stringify ici
    const payload = {
      description: donationData.project,
      client_firstname: donorInfo.firstName,
      client_lastname: donorInfo.lastName,
      email: donorInfo.email,
      phone: donorInfo.phone,
      payment_method: donationData.paymentMethod,
      amount: donationData.amount
    };

    console.log('Données envoyées à l\'API:', payload);

    if (payload.payment_method === "card") {
      // Paiement carte → formulaire natif, navigation directe, pas d'axios
    let response= redirectToPayment(payload);
      setIsProcessing(false);
      return response; // ⚠️ indispensable pour ne pas continuer vers le bloc axios ci-dessous
    }

    // Pour les autres méthodes (mobile money, etc.) → flux axios classique
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_API_URL + '/cinef/payment/initialize',
      headers: { 'Content-Type': 'application/json' },
      data: JSON.stringify(payload) // stringify seulement ici, pour axios
    };

    axios.request(config)
      .then((response) => {
        console.log(response.data);
        setShowReceipt(true);
        // traiter la réponse mobile money (probablement une URL de redirection)
        // if (response.data.url) {
        //   window.location.href = response.data.url;
        // }
      })
      .catch((error) => {
        console.log(error);
        setIsProcessing(false);
        setFailed('Le paiement a echoué. Veuillez essayer de nouveau.');
      });
  };

  const handleInputChange = (field, value) => {
    setDonorInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const resetForm = () => {
    setSelectedAmount(null);
    setCustomAmount('');
    setPaymentMethod('');
    goToStep(1);
    setShowReceipt(false);
    setDonorInfo({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      country: 'Bénin'
    });
  };

  if (showReceipt) {
    return (
      <section id="don" className="py-20 bg-gradient-to-br from-green-50 via-blue-50 to-amber-50 min-h-screen flex items-center">
        <div className="container mx-auto px-4 max-w-2xl">
          <div className="bg-white rounded-3xl shadow-2xl p-8 text-center border-2 border-green-200">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <Check className="w-12 h-12 text-white" />
            </div>

            <h2 className="text-3xl font-bold text-gray-800 mb-4">Merci pour votre don ! 🙏</h2>

            <div className="bg-green-50 rounded-2xl p-6 mb-6 border border-green-200">
              <h3 className="text-xl font-semibold text-green-800 mb-4">Récapitulatif de votre donation</h3>
              <div className="space-y-2 text-left">
                <div className="flex justify-between">
                  <span>Montant:</span>
                  <span className="font-semibold">{getCurrentAmount().toLocaleString()} FCFA</span>
                </div>
                {getFee() > 0 && (
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Frais de traitement:</span>
                    <span>{getFee().toFixed(0)} FCFA</span>
                  </div>
                )}
                <div className="flex justify-between border-t pt-2 font-bold">
                  <span>Total:</span>
                  <span>{getTotalAmount().toFixed(0)} FCFA</span>
                </div>
              </div>
            </div>

            <p className="text-gray-600 mb-6">
              Votre don contribue directement au développement de notre communauté FSF.
              Un reçu sera envoyé à votre adresse email.
            </p>

            <button
              onClick={resetForm}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-300"
            >
              Faire un autre don
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="don" className="py-20 bg-gradient-to-br from-blue-50 via-amber-50 to-pink-50 min-h-screen scroll-mt-20">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* En-tête */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <Heart className="w-8 h-8 text-red-500 animate-heart-beat" />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 font-serif">
              Faire un don à FSF
            </h1>
            <Heart className="w-8 h-8 text-red-500 animate-heart-beat" />
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soutenez notre mission d'accompagnement des couples mariés chrétiens au Bénin.
            Chaque don compte pour fortifier nos liens familiaux et spirituels.
          </p>
        </div>

        {/* Barre de progression */}
        <div className="max-w-2xl mx-auto mb-8">
          <div className="bg-gray-200 rounded-full h-2 mb-4">
            <div
              className="bg-gradient-to-r from-blue-600 to-amber-600 h-2 rounded-full transition-all duration-500 ease-in-out"
              style={{ width: `${(currentStep / 3) * 100}%` }}
            ></div>
          </div>
          <div className="text-center text-sm text-gray-600 mb-2">
            Étape {currentStep} sur 3
          </div>
        </div>

        {/* Indicateurs de progression */}
        <div className="flex items-center justify-center mb-8">
          <div className="flex items-center space-x-4">
            {[1, 2, 3].map((step) => (
              <div key={step} className="flex items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${currentStep >= step
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-600'
                  }`}>
                  {step}
                </div>
                {step < 3 && (
                  <div className={`w-12 h-1 mx-2 ${currentStep > step ? 'bg-blue-600' : 'bg-gray-200'
                    }`}></div>
                )}
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          {/* Étape 1: Choix du montant et du projet */}
          {currentStep === 1 && (
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-blue-100">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Choisissez votre contribution
              </h2>

              {/* Type de don */}
              <div className="mb-8">
                <label className="block text-lg font-semibold text-gray-700 mb-4">
                  Type de don
                </label>
                <div className="grid md:grid-cols-1 gap-4">
                  <button
                    type="button"
                    onClick={() => setDonationType('unique')}
                    className={`p-4 rounded-xl border-2 transition-all duration-300 ${donationType === 'unique'
                        ? 'border-blue-600 bg-blue-50 text-blue-800'
                        : 'border-gray-200 hover:border-blue-300'
                      }`}
                  >
                    <Gift className="w-8 h-8 mx-auto mb-2" />
                    <div className="font-semibold">Don</div>
                    <div className="text-sm text-gray-600">Contribution pour soutenir les activités de la communauté</div>
                  </button>
                  {/* <button
                    type="button"
                    onClick={() => setDonationType('mensuel')}
                    className={`p-4 rounded-xl border-2 transition-all duration-300 ${donationType === 'mensuel'
                        ? 'border-blue-600 bg-blue-50 text-blue-800'
                        : 'border-gray-200 hover:border-blue-300'
                      }`}
                  >
                    <Users className="w-8 h-8 mx-auto mb-2" />
                    <div className="font-semibold">Don mensuel</div>
                    <div className="text-sm text-gray-600">Soutien régulier</div>
                  </button> */}
                </div>
              </div>

              {/* Projet de donation */}
              <div className="mb-8">
                <label className="block text-lg font-semibold text-gray-700 mb-4">
                  Projet à soutenir
                </label>
                <div className="space-y-3">
                  {donationProjects.map((project) => (
                    <button
                      key={project.id}
                      type="button"
                      onClick={() => setSelectedProject(project.id)}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 text-left ${selectedProject === project.id
                          ? 'border-blue-600 bg-blue-50'
                          : 'border-gray-200 hover:border-blue-300'
                        }`}
                    >
                      <div className="flex items-center space-x-4">
                        <span className="text-2xl">{project.icon}</span>
                        <div>
                          <div className="font-semibold text-gray-800">{project.name}</div>
                          <div className="text-sm text-gray-600">{project.description}</div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Montants prédéfinis */}
              <div className="mb-6">
                <label className="block text-lg font-semibold text-gray-700 mb-4">
                  Montant de votre don
                </label>
                <div className="grid md:grid-cols-3 gap-4 mb-4">
                  {predefinedAmounts.map((item) => (
                    <button
                      key={item.amount}
                      type="button"
                      onClick={() => handleAmountSelect(item.amount)}
                      className={`p-4 rounded-xl border-2 transition-all duration-300 ${selectedAmount === item.amount
                          ? 'border-blue-600 bg-blue-50 text-blue-800'
                          : 'border-gray-200 hover:border-blue-300'
                        }`}
                    >
                      <div className="font-bold text-lg">{item.label}</div>
                      <div className="text-sm text-gray-600">{item.description}</div>
                    </button>
                  ))}
                </div>

                {/* Montant personnalisé */}
                <div className="relative">
                  <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type="number"
                    placeholder="Montant personnalisé (FCFA)"
                    value={customAmount}
                    onChange={(e) => handleCustomAmount(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                    min="1000"
                  />
                </div>
              </div>

              <button
                type="button"
                onClick={nextStep}
                disabled={getCurrentAmount() < 10}
                className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-colors duration-300 disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Continuer vers les informations
              </button>
            </div>
          )}

          {/* Étape 2: Informations personnelles */}
          {currentStep === 2 && (
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-blue-100">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-800">
                  Vos informations
                </h2>
                <button
                  type="button"
                  onClick={prevStep}
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-700"
                >
                  <ArrowLeft className="w-4 h-4" />
                  <span>Retour</span>
                </button>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Prénom *
                  </label>
                  <input
                    type="text"
                    required
                    value={donorInfo.firstName}
                    onChange={(e) => handleInputChange('firstName', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Nom *
                  </label>
                  <input
                    type="text"
                    required
                    value={donorInfo.lastName}
                    onChange={(e) => handleInputChange('lastName', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    required
                    value={donorInfo.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    required
                    value={donorInfo.phone}
                    onChange={(e) => handleInputChange('phone', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Adresse
                </label>
                <input
                  type="text"
                  value={donorInfo.address}
                  onChange={(e) => handleInputChange('address', e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Ville
                  </label>
                  <input
                    type="text"
                    value={donorInfo.city}
                    onChange={(e) => handleInputChange('city', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Pays
                  </label>
                  <select
                    value={donorInfo.country}
                    onChange={(e) => handleInputChange('country', e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-600 focus:outline-none"
                  >
                    <option value="Bénin">Bénin</option>
                    <option value="Togo">Togo</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Ghana">Ghana</option>
                    <option value="France">France</option>
                    <option value="Canada">Canada</option>
                    <option value="Autre">Autre</option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                onClick={nextStep}
                disabled={!donorInfo.firstName || !donorInfo.lastName || !donorInfo.email || !donorInfo.phone}
                className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-colors duration-300 disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Continuer vers le paiement
              </button>
            </div>
          )}

          {/* Étape 3: Méthode de paiement */}
          {currentStep === 3 && (
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-blue-100">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-800">
                  Méthode de paiement
                </h2>
                <button
                  type="button"
                  onClick={prevStep}
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-700"
                >
                  <ArrowLeft className="w-4 h-4" />
                  <span>Retour</span>
                </button>
              </div>

              {/* Récapitulatif */}
              <div className="bg-blue-50 rounded-2xl p-6 mb-6 border border-blue-200">
                <h3 className="text-lg font-semibold text-blue-800 mb-4">Récapitulatif</h3>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span>Donateur:</span>
                    <span className="font-semibold">{donorInfo.firstName} {donorInfo.lastName}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Montant:</span>
                    <span className="font-semibold">{getCurrentAmount().toLocaleString()} FCFA</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Type:</span>
                    <span className="capitalize">{donationType}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Projet:</span>
                    <span>{donationProjects.find(p => p.id === selectedProject)?.name}</span>
                  </div>
                </div>
              </div>

              {/* Méthodes de paiement */}
              <div className="mb-6">
                <label className="block text-lg font-semibold text-gray-700 mb-4">
                  Choisissez votre méthode de paiement
                </label>
                <div className="space-y-4">
                  {paymentMethods.map((method) => (
                    <button
                      key={method.id}
                      type="button"
                      onClick={() => setPaymentMethod(method.id)}
                      className={`w-full p-4 rounded-xl border-2 transition-all duration-300 text-left ${paymentMethod === method.id
                          ? 'border-blue-600 bg-blue-50'
                          : 'border-gray-200 hover:border-blue-300'
                        }`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <div className="text-blue-600">{method.icon}</div>
                          <div>
                            <div className="font-semibold text-gray-800">{method.name}</div>
                            <div className="text-sm text-gray-600">{method.description}</div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-sm font-medium">Frais: {method.fee}</div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Calcul des frais */}
              {paymentMethod && (
                <div className="bg-gray-50 rounded-2xl p-6 mb-6">
                  <h4 className="font-semibold text-gray-800 mb-3">Détail des coûts</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Montant du don:</span>
                      <span>{getCurrentAmount().toLocaleString()} FCFA</span>
                    </div>
                    {getFee() > 0 && (
                      <div className="flex justify-between text-sm text-gray-600">
                        <span>Frais de traitement:</span>
                        <span>{getFee().toFixed(0)} FCFA</span>
                      </div>
                    )}
                    <div className="flex justify-between border-t pt-2 font-bold">
                      <span>Total à payer:</span>
                      <span>{getTotalAmount().toFixed(0)} FCFA</span>
                    </div>
                  </div>
                </div>
              )}
              {/* Display Failed Message */}
              {failed && (
                <div className="bg-red-100 text-red-700 p-4 rounded-lg mb-6 border border-red-200">
                  {failed}
                </div>
              )}
              {/* Sécurité */}
              <div className="flex items-center justify-center space-x-2 text-sm text-gray-600 mb-6">
                <Lock className="w-4 h-4" />
                <span>Paiement sécurisé - Vos données sont protégées</span>
              </div>

              <button
                type="submit"
                disabled={!paymentMethod || isProcessing}
                className="w-full bg-green-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-green-700 transition-colors duration-300 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
              >
                {isProcessing ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    <span>Traitement en cours...</span>
                  </>
                ) : (
                  <>
                    <Heart className="w-5 h-5" />
                    <span>Finaliser le don de {getTotalAmount().toFixed(0)} FCFA</span>
                  </>
                )}
              </button>
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default DonationForm;
